import { useEffect, useState } from "react";

const Sorteo = ({dataInfo})=>{
    const [fontSize, setFontSize] = useState(50); // Tamaño de fuente inicial
    const [porcentaje, setPorcentaje] = useState(0)
    const [textBoton,setTextBoton] = useState('Participar')

    useEffect(()=>{
        dataInfo.cambioDataBoard({sorteo:dataInfo.agregado})
    },[])

    useEffect(()=>{
        if(dataInfo.agregado.estado==='Completado'){
            setTextBoton('Sorteo')
        }
        if(dataInfo.agregado.estado==='Realizado'){
            setTextBoton('Ganador')
        }
        
    },[porcentaje])

    useEffect(()=>{
        if(dataInfo.agregado.premio){
            const newFontSize = Math.max(100 - dataInfo.agregado.premio.length * 2.8, 30); // Disminuye el tamaño por cada letra extra
            setFontSize(newFontSize);
        }
    },[dataInfo.agregado.premio])
    const filtrarArray = (array) => {
        return array.filter(obj => {
            // Obtener el valor del único par clave-valor en el objeto
            const valor = Object.values(obj)[0];
    
            // Filtrar aquellos objetos cuyo valor sea exactamente ''
            return valor === '';
        });
    };
    useEffect(()=>{
        const cantVendido = dataInfo.agregado.arryPuestos.length - filtrarArray(dataInfo.agregado.arryPuestos).length;
        setPorcentaje((cantVendido * 100)/dataInfo.agregado.puestos)
        
    },[filtrarArray(dataInfo.agregado.arryPuestos).length])

    const CambioBoard = ()=>{
        dataInfo.cambioDataBoard({sorteo:dataInfo.agregado})
        if(dataInfo.agregado.estado==='Participando'){
            dataInfo.cambioBoard('compraNumeros')
        }
        if(dataInfo.agregado.estado==='Completado'){
            dataInfo.cambioBoard('AnuncioSorteo')
        }
        if(dataInfo.agregado.estado==='Realizado'){
            dataInfo.cambioBoard('AnuncioGanador')
        }
    }
    return (
        <div className="tarjeta-sorteo" key={dataInfo.agregado.id}>
            <img src={dataInfo.agregado.urlImg} alt="" />
            <div className="logo">
                {/* <img className='logoimg'src={sorteo.logoPeque} alt="" /> */}
                <img className='logoimg' src={dataInfo.data.dataEmpresa.logoPeque} alt="" />
            </div>
            <div className="content-premio">
                <h1>Premio de</h1>
                <h1 className="premio" style={{ fontSize: `${fontSize}px`, margin: 0 }}>
                    {dataInfo.agregado.typeLot === 'Express' ? dataInfo.agregado.premioBase : dataInfo.agregado.premio }
                </h1>
            </div>
            <div className="content-info">
                <p>por solo</p>
                <p className="precio">${dataInfo.agregado.valor}</p>
            </div>
            <div className="boton">
                <a href="#1" onClick={CambioBoard}>{textBoton}</a>
            </div>
            <div className="progress-bar">
                <div 
                    className="progress-fill" 
                    style={{ width: `${porcentaje}%` }}
                >
                    {porcentaje}%
                </div>
            </div>
        </div>
    )
}
export default Sorteo